import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Optional, Output, SimpleChanges, SkipSelf } from '@angular/core';
import { FormArray, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { FieldSet, OfbizField, OfbizForm, OfbizFormField } from '../ofbiz-form-model';
import { OfbizFormsService } from '../ofbiz-forms.service';
import { confirmPasswordValidator } from '../directives/password-validation.directive';
import { Observable, Subscription, merge } from 'rxjs';

@Component({
  selector: 'ubs-ofbiz-form-group',
  templateUrl: './ofbiz-form-group.component.html',
  styleUrls: ['./ofbiz-form-group.component.scss']
})
/**
 * @description
 * A class to represent group fields of a nested form.
 * The field group is based on a fieldset passed in alongside all the fields and the ofbizForm.
 */
export class OfbizFormGroupComponent implements OnChanges, OnInit {
  /**
   * @description
   * Object consisting of a fieldSetName and a collection of field names.
   * The fieldSetName is used to resolve the formGroupName.
   */
  @Input() fieldSet: FieldSet;
  @Input() ofbizForm: OfbizForm;
  @Input() fields: OfbizField[];
  @Input() arrayIndex: number;
  @Input() formGroup: FormGroup;

  formGroupName: string;
  // form: FormGroup;
  form: FormGroup;
  formFields: any[];
  hiddenFields: OfbizFormField<any>[];

  formValueChanges: Subscription;
  controlValidation = {};
  endPoint: string;
  /**
   * Emitter to indicate whether an formGroup array is valid.  Used in stepper forms to enable the next step
   */
  @Output() arrayValid: EventEmitter<any> = new EventEmitter<any>();
  /**
   * Emits the response from the form submission to the consuming component
   */
  @Output() formResponse: EventEmitter<any> = new EventEmitter<any>();

  constructor(private ofbizFormSerive: OfbizFormsService, @Optional() @SkipSelf() private rootFormGroup: FormGroupDirective) { }

  ngOnInit(): void {
    // code moved to ngOnChanges to ensure formGroup is resolved before trying to access form controls and called from runValidation.
    /* setTimeout(() => {
      this.form.touched;
      this.validateControls();
      if (Object.values(this.controlValidation).includes(false)) {
        this.arrayValid.emit({ index: this.arrayIndex, valid: false })
      } else {
        this.arrayValid.emit({ index: this.arrayIndex, valid: true })
      }
    }, 300) */

  }



  ngOnChanges(changes: SimpleChanges): void {
    // Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    // Add '${implements OnChanges}' to the class.
    if (changes["fields"]) {
      console.log("Fields changed", this.fields);
    }
    if (changes["fieldSet"] || changes['formGroup']) {
      // console.log(this.fieldSet);
      this.formGroupName = this.fieldSet.fieldSetName;
      if (this.formGroup) {
        console.log(this.formGroup);
        this.form = this.formGroup;
        // Add password validation
        if (this.form.controls["password"] && this.form.controls["confirmPassword"]) {
          console.log("Has password and confirmPassword")

          // Next to lines is the alternative, Uncomment an comment out value Changes subscription above
          this.form.addValidators(this.ofbizFormSerive.passwordMatch('password', 'confirmPassword'));
          this.form.updateValueAndValidity({ emitEvent: false })


        } else {
          console.log("NO Has password and confirmPassword")
        }
        const filteredFormGroupFields: any = this.getFilteredFormGroupFields(this.fieldSet.fields, this.fields);
        if (filteredFormGroupFields != null && filteredFormGroupFields != undefined) {
          this.ofbizFormSerive.getFormFields(filteredFormGroupFields)
            .subscribe((formFields: OfbizFormField<any>[]) => {
              this.formFields = formFields;
            })
        }
        const valueChangeWatches: Observable<any>[] = this.getControlValueChangeObs(this.form);
        this.formValueChanges = merge(valueChangeWatches).subscribe((changes) => {
          changes.subscribe((stuff) => {
            // console.log(stuff);
            // console.log(this.form.valid);
            // let controlValidation = {};
            this.validateControls();
            // console.log(controlValidation)
            if (Object.values(this.controlValidation).includes(false)) {
              console.log(this.arrayIndex, "FALSE"); this.arrayValid.emit({ index: this.arrayIndex, valid: false })
            } else {
              this.arrayValid.emit({ index: this.arrayIndex, valid: true })
            }
          })
        })
        this.runValidation();
      }
      /* setTimeout(() => {                           // <<<---using ()=> syntax
        console.log(this.rootFormGroup);
        this.formGroupName = this.fieldSet.fieldSetName;
        if (this.rootFormGroup) {
          this.form = this.rootFormGroup.control.get(this.formGroupName) as FormGroup;
          console.log(`form: ${this.form}, formGroupName: ${this.formGroupName}`);
          Object.keys(this.form.controls).forEach((key: string) => {
            console.log("formControlName : " + key);
          });

          if (this.form.controls["password"] && this.form.controls["confirmPassword"]) {
            console.log("Has password and confirmPassword")

            // Next to lines is the alternative, Uncomment an comment out value Changes subscription above
            this.form.addValidators(this.ofbizFormSerive.passwordMatch('password', 'confirmPassword'));
            this.form.updateValueAndValidity({ emitEvent: false })


          } else {
            console.log("NO Has password and confirmPassword")
          }
          // this.hiddenFields = this.fields.filter(field => field.controlType == 'hidden');
          console.log({ FormGroupControls: this.form.controls, Fields: this.fields, OfbizForm: this.ofbizForm });
          const filteredFormGroupFields: any = this.getFilteredFormGroupFields(this.fieldSet.fields, this.fields);
          if (filteredFormGroupFields != null && filteredFormGroupFields != undefined) {
            this.ofbizFormSerive.getFormFields(filteredFormGroupFields)
              .subscribe((formFields: OfbizFormField<any>[]) => {
                this.formFields = formFields;
              })
          }
          const valueChangeWatches: Observable<any>[] = this.getControlValueChangeObs(this.form);
          this.formValueChanges = merge(valueChangeWatches).subscribe((changes) => {
            changes.subscribe((stuff) => {
              // console.log(stuff);
              // console.log(this.form.valid);
              // let controlValidation = {};
              this.validateControls();
              // console.log(controlValidation)
              if (Object.values(this.controlValidation).includes(false)) {
                console.log(this.arrayIndex, "FALSE"); this.arrayValid.emit({ index: this.arrayIndex, valid: false })
              } else {
                this.arrayValid.emit({ index: this.arrayIndex, valid: true })
              }
            })
          })
          this.runValidation();
        }
      }, 3000); */



      // console.log({FormGroupName:this.formGroupName})
      // this.form = this.rootFormGroup.control.get(this.formGroupName) as FormGroup;
    }
  }

  getFilteredFormGroupFields(fieldSetFieldNames: string[], fields: OfbizField[]): OfbizField[] {
    const filteredFormGroupFields: OfbizField[] = [];
    fieldSetFieldNames.forEach(fieldName => {
      const filteredFormGroupField = fields.find(field => field.name == fieldName);
      if (filteredFormGroupField) {
        filteredFormGroupFields.push(filteredFormGroupField)
      }
    })
    return filteredFormGroupFields
  }

  getControlValueChangeObs(form: FormGroup) {
    const watchers = [];
    Object.keys(form.controls).forEach(ctl => {
      const control = form.get(ctl);
      watchers.push(control.valueChanges);
    });
    return watchers;
  }

  validateControls() {
    Object.keys(this.form.controls).forEach(ctl => {
      const control = this.form.get(ctl)
      this.controlValidation[ctl] = control.valid;
    });
  }

  private runValidation(): void {
    if (!this.form) return;
    this.form.touched;
    this.validateControls();
    if (Object.values(this.controlValidation).includes(false)) {
      this.arrayValid.emit({ index: this.arrayIndex, valid: false });
    } else {
      this.arrayValid.emit({ index: this.arrayIndex, valid: true });
    }
  }

  setEndpoint(endPoint: string): void {
    this.endPoint = endPoint;
  }



  get isFormValid() {
    return this.form.valid;
    // return this.form.control
  }
  /**
   *
   * @param endpoint Endpoint for the form submission
   */
  submit(): void {
    /* console.log("We are here");
    console.log(this.rootFormGroup.control.get("personalInfo").value);
    console.log(this.rootFormGroup.value); */
    console.log(this.endPoint);
    console.log(this.rootFormGroup.value)
    console.log(this.form.value)
    const formData = new FormData();
    for (const [key, value] of Object.entries(this.rootFormGroup.value)) {
      console.log(key, value);
      for (const [k, v] of Object.entries(value)) {
        formData.append(k, v);
      }

    }
    this.ofbizFormSerive.postFormDataTest(formData, this.endPoint).subscribe(resp => {

      this.formResponse.emit(resp["data"]);
    })
  }


}
